import { useTranslation } from 'react-i18next';
import React from "react";
import "./dataPushAndPull.scss";

function DataPushAndPull() {
    const { t } = useTranslation()
  
    return (
        <div className="container-data-push">
            <div className="texts-data-push">
                <h1>{t("realtime_data.data_push_and_pull.title")}</h1>
                <p>{t("realtime_data.data_push_and_pull.section_text")}</p>
            </div>
        </div>
    )
  }
  

export default DataPushAndPull;